import React from 'react';
import {
  View,
  Text,
  Image,
  TouchableOpacity,
  StyleSheet,
  Platform,
  useWindowDimensions,
} from 'react-native';

import maleAvatar from 'images/RPM/male_double_side.png';
import femaleAvatar from 'images/RPM/female_double_side.png';

import { TYPE, FONTS } from 'style/typography';

// ✅ If you have the logo asset, import it here
// import rpmLogo from 'images/RPM/ready_player_me_logo.png';

const AvatarCreateOverlay = ({visible, onPressCreate}) => {
  const {width, height} = useWindowDimensions();

return null;

  if (Platform.OS !== 'web' || !visible) return null;

  // ✅ Layout max width (similar to screenshot)
  const containerWidth = 1000
  const containerHeight = 650 * 0.8

  const titleSize = TYPE['4xl'];

  return (
    <View style={styles.overlay} pointerEvents="auto">

      {/* ✅ Main centered content */}
      <View
        style={[
          styles.contentWrap,
          {
            width: containerWidth,
            height: containerHeight,
          },
        ]}>
        {/* LEFT (Text + CTA) */}
        <View style={styles.leftWrap}>
          <Text style={[styles.title, {
            fontSize: titleSize,
            fontFamily: FONTS.heading,
          }]}>
            Let’s create{'\n'}your avatar!
          </Text>

          <TouchableOpacity
            accessibilityRole="button"
            onPress={onPressCreate}
            style={styles.button}>
            <Text style={styles.buttonText}>Start Creating</Text>
          </TouchableOpacity>
        </View>

        {/* RIGHT (Avatars) */}
        <View style={styles.rightWrap}>
          <Image
            source={maleAvatar}
            style={styles.avatarImg}
            resizeMode="cover"
            accessibilityLabel="Male avatar preview"
          />

          <Image
            source={femaleAvatar}
            style={styles.avatarImg}
            resizeMode="cover"
            accessibilityLabel="Female avatar preview"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 9999,
    backgroundColor: '#000',
    justifyContent: 'center',
    alignItems: 'center',
  },

  // ✅ Logo at top center (like screenshot)
  logoWrap: {
    position: 'absolute',
    top: 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoText: {
    color: '#fff',
    fontWeight: '700',
    fontSize: TYPE.xl,
    fontFamily: FONTS.body,
    textAlign: 'center',
    letterSpacing: 1,
    lineHeight: 25,
  },
  // logoImg: { width: 120, height: 80 },

  // ✅ Main content box
  contentWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 100,
  },

  // ✅ Left section (text + button)
  leftWrap: {
    width: '38%',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: '#fff',
    fontWeight: '700',
    lineHeight: 64,
    marginBottom: 28,
    width: '100%',
    textAlign: 'center',
    alignItems:'center',
    justifyContent:'center',
  },

  // ✅ Button style matching screenshot
  button: {
    backgroundColor: '#CBEA4C',
    paddingVertical: 18,
    paddingHorizontal: 24,
    borderRadius: 14,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    color: '#111',
    fontWeight: '600',
    fontSize: TYPE.lg,
    fontFamily: FONTS.body,
    width: '100%',
    textAlign: 'center',
  },

  // ✅ Right side avatars
  rightWrap: {
    width: '58%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    paddingTop: 40, // 
  },
  avatarImg: {
    width: 200,
    height: 480,
  },
});

export default AvatarCreateOverlay;
